import { Button, Checkbox, Typography } from "@mui/material";
import { formatCurrency } from "src/helper/convertNum";
import useDebtWarehouseHistoryList from "src/hooks/debt/useDebtWarehouseHistoryList";
import { v4 as uuid } from "uuid";
import dayjs from "dayjs";
import convertCurrency from "src/helper/convertCurrency";
import useSummaryDebt from "src/hooks/debt/useSummaryDebt";
import { useState } from "react";
import useAuthGlobal from "src/context/useAuthGlobal";
import { CONTEXT_TYPE, HISTORY_TYPE } from "../const/constants";
export default function useDebtWarehouseHistoryTab({ date, filter }) {
  const [selectedRow, setSelectedRow] = useState(null);
  const [pagi, setPagi] = useState({ limit: 50, skip: 0 });
  const { userMe } = useAuthGlobal();
  const { data: summaryDebt } = useSummaryDebt({
    warehouse: userMe?.currentWarehouse?._id,
    contextType: CONTEXT_TYPE.TRANSFER,
  });
  const { data } = useDebtWarehouseHistoryList({
    type: HISTORY_TYPE.WAREHOUSE,
    fromDate: date?.fromDate ?? undefined,
    toDate: date?.toDate ?? undefined,
    ...filter,
    ...pagi,
    skip: filter?.page,
    limit: filter?.limit,
  });
  const handleView = (item) => {
    setSelectedRow(item);
  };

  let bodyList = data?.data?.map((item, index) => ({
    ...item,
    checkbox: <Checkbox checked={item.checked} />,
    stt: index + 1,
    paymentDate: <Typography>{item?.paymentDate ? dayjs(item?.paymentDate).format("DD/MM/YYYY") : "-"}</Typography>,
    warehouseSupplier: <Typography>{item?.warehouse?.name ?? "-"}</Typography>,
    accountant: <Typography>{item?.sales?.fullName ?? "-"}</Typography>,
    paymentMethod: <Typography>{item?.method ?? "-"}</Typography>,
    receiveAccount: (
      <Typography
        sx={{ maxWidth: 260 }}
        noWrap
      >
        {item?.bankInfo?.accountNumber ?? "-"}
      </Typography>
    ),
    totalDebt: (
      <>
        <Typography fontWeight="bold">+{formatCurrency(item?.totalReceived)}</Typography>
        <Typography
          color="#989898"
          fontSize="8px"
          fontStyle="italic"
        >
          {convertCurrency(item?.totalReceived)} đồng
        </Typography>
      </>
    ),
    paid: (
      <>
        <Typography fontWeight="bold">-{formatCurrency(item?.totalPaid)}</Typography>
        <Typography
          color="#989898"
          fontSize="8px"
          fontStyle="italic"
        >
          {convertCurrency(item?.totalPaid)} đồng
        </Typography>
      </>
    ),
    balance: (
      <>
        <Typography fontWeight="bold">
          {item?.balanceAfter < 0 ? "-" : "+"}
          {formatCurrency(Math.abs(item?.balanceAfter))}
        </Typography>
        <Typography
          color="#989898"
          fontSize="8px"
          fontStyle="italic"
        >
          {convertCurrency(item?.balanceAfter)} đồng
        </Typography>
      </>
    ),
    action: (
      <Button
        variant="outlined"
        onClick={() => handleView(item)}
        sx={{ minWidth: "100px" }}
      >
        Chi tiết
      </Button>
    ),
  }));

  let header = [
    {
      id: uuid(),
      title: <Checkbox />,
      align: "center",
    },
    {
      id: uuid(),
      title: "STT",
      align: "center",
    },
    {
      id: uuid(),
      title: "Ngày thanh toán",
      align: "center",
    },
    {
      id: uuid(),
      title: "Kho/ NCC",
      align: "center",
    },
    {
      id: uuid(),
      title: "Kế toán xử lý",
      align: "center",
    },
    {
      id: uuid(),
      title: "Hình thức TT",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tài khoản nhận TT",
      align: "center",
    },
    {
      id: uuid(),
      title: "Tồn công nợ",
      align: "center",
    },
    {
      id: uuid(),
      title: "Đã thanh toán",
      align: "center",
    },
    {
      id: uuid(),
      title: "Số dư",
      align: "center",
    },
    {
      id: uuid(),
      title: "Thao tác",
      align: "center",
    },
  ];

  const sortData = ["checkbox", "stt", "paymentDate", "warehouseSupplier", "accountant", "paymentMethod", "receiveAccount", "totalDebt", "paid", "balance", "action"];

  const footerTotals = {
    all: summaryDebt?.data?.all ?? 0,
    paid: summaryDebt?.data?.paid ?? 0,
    unpaid: summaryDebt?.data?.unpaid ?? 0,
  };

  return { bodyList, header, pagi, setPagi, total: data?.count ?? 0, sortData, footerTotals, selectedRow, setSelectedRow };
}
